import {FavoriteVehicle, FavoriteAction} from '@shared/interfaces';

export enum ActionTypes {
  GET_MAKES = '[Vehicle] GetMakes',
  GET_MODELS = '[Vehicle] GetModelsData',
  GET_FAVORITE_VEHICLES_DATA = '[Vehicle] GetFavoriteVehiclesData',
  GET_FAVORITE_VEHICLES_ID = '[Vehicle] GetFavoriteVehiclesId',
  SET_FAVORITE_VEHICLES = '[Vehicle] SetFavoriteVehicles',
}

export class GetMakes {
  static readonly type = ActionTypes.GET_MAKES;
}

export class GetModelsData {
  static readonly type = ActionTypes.GET_MODELS;

  constructor(public payload: { make: string }) {
  }
}

export class GetFavoriteVehiclesData {
  static readonly type = ActionTypes.GET_FAVORITE_VEHICLES_DATA;
}

export class GetFavoriteVehiclesId {
  static readonly type = ActionTypes.GET_FAVORITE_VEHICLES_ID;
}

export class SetFavoriteVehicle {
  static readonly type = ActionTypes.SET_FAVORITE_VEHICLES;

  constructor(public payload: { vehicleId: string; action: FavoriteAction; vehicleData: FavoriteVehicle }) {
  }
}

